export default "__VITE_ASSET__d3f13b3c__"